import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Admin, Login } from 'containers';
import styles from './styles';

class Root extends Component {
  render = () => {
    const { signedIn, loading, classes } = this.props;
    if (loading) {
      return null;
    } else {
      return signedIn ? <Admin /> : <Login />;
    }
  }
}

const mapStateToProps = (state) => {
  const signedIn = state.auth.getIn(['user', 'isSignedIn']);
  const loading = state.auth.getIn(['authenticate', 'loading']);
  return { signedIn, loading };
};

const component = connect(mapStateToProps)(Root);
export default withStyles(styles)(component);



// WEBPACK FOOTER //
// ./src/containers/Root/index.js